/* GemsMantra product rails (home page). Each product row scrolls sideways: arrows on
   desktop, swipe on phones, a thin progress line under the row and a "view all" card at
   the end. Works on any row marked in RAILS below; loaded by gm-header-polish on index. */
(function () {
  var RAILS = [
    { track: '.Mxcp-new-arrivals-section--grid .Mxcp-na-track', host: '.Mxcp-na-carousel-wrap', more: '.Mxcp-na-view-all', scope: '.Mxcp-new-arrivals-section', img: '.Mxcp-na-img-wrap' },
    { track: '.gm-ar__grid', host: '.gm-ar__panel', more: '.gm-ar__more', scope: '.gm-ar__panel', img: '.gm-ar__img' },
    { track: '.gmfs__row', host: '.gmfs__w', more: '.gmfs__foot a', scope: '.gmfs', img: '.gmfs__img' }
  ];
  var ARROW = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function track(name, label) {
    try { if (window.clarity) window.clarity('event', name); } catch (e) {}
    try { if (typeof window.gmGtmConsentAllowed === 'function' && window.gmGtmConsentAllowed()) { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'gm_rail', action: name, rail: label }); } } catch (e) {}
  }
  var rails = [], frame = 0;
  function schedule() {
    if (!frame) frame = requestAnimationFrame(flush);
  }
  function flush() {
    frame = 0;
    var active = rails.filter(function (rail) { return rail.el.isConnected; });
    var states = active.map(function (rail) { return rail.activation(); });
    var changed = false;
    states.forEach(function (state, i) {
      if (active[i].activate(state)) changed = true;
    });
    if (changed) { schedule(); return; }
    var measurements = active.map(function (rail) { return rail.measure(); });
    measurements.forEach(function (measurement, i) { active[i].paint(measurement); });
  }
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  function setup(cfg, el) {
    if (el.getAttribute('data-gm-rail')) return;
    el.setAttribute('data-gm-rail', '1');
    el.classList.add('gm-rail');
    var scope = el.closest(cfg.scope) || el.parentNode;
    var host = el.closest(cfg.host) || el.parentNode;
    var label = (scope.querySelector('h2') || {}).textContent || 'rail';
    label = label.trim().slice(0, 40);
    host.classList.add('gm-rail-host');
    var more = scope.querySelector(cfg.more);
    if (more && more.href) {
      var end = document.createElement('a');
      end.className = 'gm-rail-end';
      end.href = more.href;
      end.setAttribute('data-gm-track', 'rail_view_all');
      end.innerHTML = '<span class="gm-rail-end__in"><span class="gm-rail-end__t"></span><span class="gm-rail-end__a">' + ARROW + '</span></span>';
      end.querySelector('.gm-rail-end__t').textContent = more.textContent.replace(/[→\s]+$/, '').trim() || 'View all';
      el.appendChild(end);
      end.style.setProperty('display', 'block', 'important'); /* older theme rules hide row children after the 8th */
    }
    var prev = document.createElement('button'), next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'gm-rail-btn gm-rail-btn--prev'; next.className = 'gm-rail-btn gm-rail-btn--next';
    prev.setAttribute('aria-label', 'Previous products'); next.setAttribute('aria-label', 'More products');
    prev.innerHTML = next.innerHTML = ARROW;
    var bar = document.createElement('div'); bar.className = 'gm-rail-bar'; bar.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('i'); bar.appendChild(thumb);
    el.parentNode.insertBefore(prev, el);
    el.parentNode.insertBefore(next, el.nextSibling);
    next.parentNode.insertBefore(bar, next.nextSibling);
    function step() {
      var c = el.querySelector(':scope > *:not([style*="none"])');
      var w = c ? c.getBoundingClientRect().width : el.clientWidth / 4;
      var gap = parseFloat(getComputedStyle(el).columnGap) || 16;
      var per = Math.max(1, Math.floor((el.clientWidth + gap) / (w + gap)));
      return per * (w + gap);
    }
    function activation() {
      return el.scrollWidth - el.clientWidth > 4;
    }
    function activate(on) {
      if (host.classList.contains('gm-rail-host--on') === on) return false;
      host.classList.toggle('gm-rail-host--on', on);
      return true;
    }
    function measure() {
      var width = el.clientWidth, full = el.scrollWidth, left = el.scrollLeft;
      var max = full - width, on = max > 4;
      var ratio = on ? Math.max(0.12, width / full) : 1;
      var p = on ? left / max : 0;
      var img = el.querySelector(cfg.img);
      var hr = host.getBoundingClientRect();
      var y = img ? img.getBoundingClientRect().top - hr.top + img.offsetHeight / 2 : null;
      var vw = document.documentElement.clientWidth;
      return { previous: !on || left <= 4, next: !on || left >= max - 4,
        width: (ratio * 100) + '%', left: (p * (1 - ratio) * 100) + '%',
        y: y, right: inset(vw - hr.right), insetLeft: inset(hr.left) };
    }
    var painted = {};
    function setStyle(style, property, value, key, custom) {
      var current = custom ? style.getPropertyValue(property) : style[property];
      var prior = painted[key];
      if (prior && prior.value === value && prior.actual === current) return;
      if (current !== value) {
        if (custom) style.setProperty(property, value); else style[property] = value;
      }
      painted[key] = { value: value, actual: custom ? style.getPropertyValue(property) : style[property] };
    }
    function paint(state) {
      if (prev.disabled !== state.previous) prev.disabled = state.previous;
      if (next.disabled !== state.next) next.disabled = state.next;
      setStyle(thumb.style, 'width', state.width, 'width');
      setStyle(thumb.style, 'left', state.left, 'left');
      if (state.y !== null) setStyle(host.style, '--gm-rail-y', state.y + 'px', 'y', true);
      setStyle(next.style, 'right', state.right, 'right');
      setStyle(prev.style, 'left', state.insetLeft, 'insetLeft');
    }
    function inset(space) {
      if (space >= 16) return '-14px';
      if (space >= 4) return (2 - space) + 'px';
      return '6px';
    }
    rails.push({ el: el, activation: activation, activate: activate, measure: measure, paint: paint });
    el.addEventListener('scroll', schedule, { passive: true });
    prev.addEventListener('click', function () { el.scrollBy({ left: -step(), behavior: 'smooth' }); track('rail_prev', label); });
    next.addEventListener('click', function () { el.scrollBy({ left: step(), behavior: 'smooth' }); track('rail_next', label); });
    var swiped = false;
    el.addEventListener('touchmove', function () { if (!swiped) { swiped = true; track('rail_swipe', label); } }, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(el);
    schedule();
  }
  function init() {
    RAILS.forEach(function (cfg) { document.querySelectorAll(cfg.track).forEach(function (el) { setup(cfg, el); }); });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
